import React from 'react';
import { SaveStatus } from '@/types/common';
import { Spinner } from '@/components/ui/spinner';
import { CheckIcon, XIcon, RefreshCcw } from 'lucide-react';

interface SaveIndicatorProps {
    status: SaveStatus;
}

export const SaveIndicator: React.FC<SaveIndicatorProps> = ({ status }) => {
    return (
        <div className="text-sm flex items-center">
            {status.status === 'saving' && (
                <span className="text-yellow-600 flex items-center">
                    <Spinner className="w-4 h-4 mr-2" />
                    Salvando alterações...
                </span>
            )}
            {status.status === 'saved' && (
                <span className="text-green-600 flex items-center">
                    <CheckIcon className="w-4 h-4 mr-2" />
                    Todas as alterações salvas {status.lastSaved && 
                        `às ${status.lastSaved.toLocaleTimeString()}`
                    }
                </span>
            )}
            {status.status === 'error' && (
                <span className="text-red-600 flex items-center">
                    <XIcon className="w-4 h-4 mr-2" />
                    Falha ao salvar: {status.error}
                </span>
            )}
            {status.status === 'retrying' && (
                <span className="text-yellow-600 flex items-center">
                    <RefreshCcw className="w-4 h-4 mr-2 animate-spin" />
                    Tentando salvar novamente... (Tentativa {status.retryCount} de 3)
                </span>
            )}
        </div>
    );
};
